/**
 * Do not edit directly.
 * Generated via Design Token Pipeline
 */
import React from 'react';
import { convertIconPropsToSvgProps } from '../../utils';
export const IconMerge = React.forwardRef((iconProps, ref) => {
    const props = convertIconPropsToSvgProps({
        ...iconProps,
        'aria-label': 'icon-merge',
    });
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ref: ref, ...props },
        React.createElement("g", null,
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.385 6.293v-.006.007a1.096 1.096 0 1 1 0-.007v.006Zm.658 2.776a3.288 3.288 0 1 0-2.85.319v7.68a3.289 3.289 0 1 0 2.192 0v-5.122a8.38 8.38 0 0 0 6.21 2.743h2.014a3.289 3.289 0 1 0 0-2.192h-2.013A6.21 6.21 0 0 1 8.043 9.07Zm10.667 5.62a1.095 1.095 0 1 0 0-2.19 1.095 1.095 0 0 0 0 2.19ZM6.29 21.265a1.096 1.096 0 1 0 0-2.192 1.096 1.096 0 0 0 0 2.192Z" })),
        React.createElement("defs", null,
            React.createElement("clipPath", null,
                React.createElement("path", { d: "M0 0h24v24H0z" })))));
});
IconMerge.displayName = 'IconMerge';
export default IconMerge;
